import type { ModalProps } from 'antd';

/**
 * 长表单 Modal：仅内容区（body）纵向滚动，页脚「确定/取消」固定在弹窗底部可见。
 * 用于 Ant Design 5 `Modal` 的 `styles` 属性。
 */
export const modalFormBodyScrollStyles: ModalProps['styles'] = {
  body: {
    maxHeight: 'min(72vh, calc(100vh - 240px))',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
};
